import { WestpacEnvironment } from 'global-types';

export const environment: WestpacEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://bsa-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://myofferssso.banksa.com.au',
  clientId: '38be6bdb-6cfd-470f-b933-314e69fc493c',
  connection: 'westpac',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://myoffers.banksa.com.au',
  stripeApiKey:
    'pk_live_51I3Ys9LXeLt2fiomdRC4oR5TXEARjEI5Lg5NzAO81980KWASiSJHE8DfiO5Zn91ELirdFg0IKG3P8w0eNF7qrmz300i3Ket73A',
  travelEdgeBaseUrl: 'https://myoffershotels.banksa.com.au',
  brandName: 'BankSA',
  shortBrandName: 'BSA',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 600,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 180,
  sessionCheckRetryThreshold: 10,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'banksa.com.au',
  },
  appId: '915ea31b-7930-4a4b-b484-b25197faa12c',
  unleashAppName: 'rd-bsa-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
